import i18n from "@/i18n";

export const CURRENCY_SYMBOL = {
  INR: "₹", USD: "$", GBP: "£", EUR: "€", SGD: "S$", KES: "KSh", AUD: "A$",
};

const dateLocale = () => (i18n.language === "hi" ? "hi-IN" : "en-GB");

export function money(value, currency = "INR", compact = false) {
  const n = Number(value || 0);
  const sym = CURRENCY_SYMBOL[currency] || `${currency} `;
  if (compact) {
    if (Math.abs(n) >= 10000000) return `${sym}${(n / 10000000).toFixed(2)} ${i18n.t("Cr")}`;
    if (Math.abs(n) >= 100000) return `${sym}${(n / 100000).toFixed(2)} ${i18n.t("L")}`;
    if (Math.abs(n) >= 1000) return `${sym}${(n / 1000).toFixed(1)}k`;
  }
  return `${sym}${n.toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
}

export function num(value) {
  return Number(value || 0).toLocaleString("en-IN");
}

export function pct(part, whole) {
  if (!whole) return "0%";
  return `${Math.round((Number(part) / Number(whole)) * 100)}%`;
}

export function shortDate(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString(dateLocale(), { day: "2-digit", month: "short", year: "numeric" });
}

export function dateTime(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleString(dateLocale(), {
    day: "2-digit", month: "short", year: "2-digit", hour: "2-digit", minute: "2-digit",
  });
}

export function hashShort(hash) {
  if (!hash) return "—";
  return `${hash.slice(0, 10)}…${hash.slice(-6)}`;
}

export const LIFECYCLE_ORDER = [
  "DRAFT", "SOURCE_VERIFIED", "ANALYST_REVIEW", "LEGAL_REVIEW",
  "APPROVED", "PUBLISHED", "SUSPENDED", "RETIRED",
];

export const LIFECYCLE_STYLE = {
  DRAFT: "bg-muted text-muted-foreground border-border",
  SOURCE_VERIFIED: "bg-cyan-500/10 text-cyan-700 dark:text-cyan-300 border-cyan-500/30",
  ANALYST_REVIEW: "bg-violet-500/10 text-violet-700 dark:text-violet-300 border-violet-500/30",
  LEGAL_REVIEW: "bg-amber-500/10 text-amber-700 dark:text-amber-300 border-amber-500/30",
  APPROVED: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 border-emerald-500/30",
  PUBLISHED: "bg-primary/10 text-primary border-primary/30",
  SUSPENDED: "bg-red-500/10 text-red-700 dark:text-red-300 border-red-500/30",
  RETIRED: "bg-muted text-muted-foreground/70 border-border",
};

export const DECISION_STYLE = {
  BLOCK: "bg-red-500/10 text-red-700 dark:text-red-300 border-red-500/40",
  REQUIRE_APPROVAL: "bg-amber-500/10 text-amber-700 dark:text-amber-300 border-amber-500/40",
  WARN: "bg-yellow-500/10 text-yellow-700 dark:text-yellow-300 border-yellow-500/40",
  INFORM: "bg-blue-500/10 text-blue-700 dark:text-blue-300 border-blue-500/40",
  PASS: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 border-emerald-500/40",
};

export const SEVERITY_STYLE = {
  block: DECISION_STYLE.BLOCK,
  require_approval: DECISION_STYLE.REQUIRE_APPROVAL,
  warn: DECISION_STYLE.WARN,
  inform: DECISION_STYLE.INFORM,
};

export const CASCADE_LABELS = {
  global: "Global", regional_overlay: "Regional Overlay", country: "Country",
  sub_jurisdiction: "Sub-Jurisdiction", legal_form: "Legal Form",
  charity_classification: "Charity Classification", tax_status: "Tax Status",
  activity: "Activity", fund_source: "Fund Source", transaction_type: "Transaction Type",
  beneficiary_data_class: "Beneficiary Data Class", reporting_period: "Reporting Period",
};

export const COUNTRY_NAME = {  GL: "Global", IN: "India", GB: "United Kingdom", US: "United States", SG: "Singapore",
  KE: "Kenya", AU: "Australia", EU: "European Union", RU: "Russia",
};
